/**
 * Haversine distance in meters.
 */
export function distanceMeters(lat1, lng1, lat2, lng2) {
  const R = 6371000;
  const toRad = (d) => (d * Math.PI) / 180;
  const dPhi = toRad(lat2 - lat1);
  const dL = toRad(lng2 - lng1);
  const a =
    Math.sin(dPhi / 2) ** 2 +
    Math.cos(toRad(lat1)) * Math.cos(toRad(lat2)) * Math.sin(dL / 2) ** 2;
  return 2 * R * Math.asin(Math.sqrt(a));
}

/**
 * Wrap navigator.geolocation in a promise.
 * Returns { lat, lng, accuracy }.
 */
export function getCurrentPosition(opts = {}) {
  return new Promise((resolve, reject) => {
    if (!navigator.geolocation) {
      reject(new Error("Browser tidak mendukung geolokasi"));
      return;
    }
    navigator.geolocation.getCurrentPosition(
      (pos) =>
        resolve({
          lat: pos.coords.latitude,
          lng: pos.coords.longitude,
          accuracy: pos.coords.accuracy,
        }),
      (err) => reject(new Error(translateGeoError(err))),
      { enableHighAccuracy: true, timeout: 15000, maximumAge: 0, ...opts },
    );
  });
}

function translateGeoError(err) {
  switch (err.code) {
    case err.PERMISSION_DENIED:
      return "Izin lokasi ditolak. Aktifkan GPS dan izinkan akses lokasi.";
    case err.POSITION_UNAVAILABLE:
      return "Posisi tidak tersedia. Pastikan GPS aktif dan coba lagi.";
    case err.TIMEOUT:
      return "Timeout mendapatkan lokasi. Coba lagi.";
    default:
      return err.message || "Gagal mendapatkan lokasi.";
  }
}

/**
 * Compress image data URL by drawing into canvas at max width.
 */
export function compressImageDataUrl(dataUrl, maxWidth = 720, quality = 0.7) {
  return new Promise((resolve, reject) => {
    const img = new Image();
    img.onload = () => {
      const scale = Math.min(1, maxWidth / img.width);
      const w = Math.round(img.width * scale);
      const h = Math.round(img.height * scale);
      const canvas = document.createElement("canvas");
      canvas.width = w;
      canvas.height = h;
      const ctx = canvas.getContext("2d");
      ctx.drawImage(img, 0, 0, w, h);
      resolve(canvas.toDataURL("image/jpeg", quality));
    };
    img.onerror = (e) => reject(e);
    img.src = dataUrl;
  });
}

export function fileToDataUrl(file) {
  return new Promise((resolve, reject) => {
    const r = new FileReader();
    r.onload = () => resolve(r.result);
    r.onerror = () => reject(new Error("Gagal membaca file"));
    r.readAsDataURL(file);
  });
}

export function formatJam(iso) {
  if (!iso) return "—";
  try {
    return new Date(iso).toLocaleTimeString("id-ID", { hour: "2-digit", minute: "2-digit" });
  } catch {
    return "—";
  }
}
